module.exports = __webpack_public_path__ + "img/qz-tray.165942dc.jpg";